import { AuthAccountEnvironment } from './interface';
import { AuthAccountEnvironmentMetaData } from '../../../../containers/pipeline/interfaces/source-type';
import { DEFAULT_AUTH_ACCOUNT_ENVIRONMENTS_METADATA } from './constants';

export function getAuthEnvironmentLabel(env: AuthAccountEnvironment, metaData: { [key: string]: AuthAccountEnvironmentMetaData }) {
  if (metaData
    && metaData[env]
    && metaData[env].label) {
    return metaData[env].label;
  }

  return DEFAULT_AUTH_ACCOUNT_ENVIRONMENTS_METADATA[env].label;
}

export function getAuthEnvironmentDescription(env: AuthAccountEnvironment, metaData: { [key: string]: AuthAccountEnvironmentMetaData }) {
  if (metaData
    && metaData[env]
    && metaData[env].description) {
    return metaData[env].description;
  }

  return DEFAULT_AUTH_ACCOUNT_ENVIRONMENTS_METADATA[env].description;
}
